export function getFileExt(filename: string): string {
    const separatedFilename = filename.split(".");
    return separatedFilename[separatedFilename.length - 1];
}